// Matches the backend's MAX_BODY_LENGTH (communications.validator.ts).
export const MAX_ENTRY_BODY_LENGTH = 10000;
